export enum DriverSeatUserActionTypes {
    SET_DRIVER_SEAT_USER = "SET_DRIVER_SEAT_USER",
    CLEAR_DRIVER_SEAT_USER = "CLEAR_DRIVER_SEAT_USER"
}